const loginHelpDeliveryOptionsTemplate = `<pwr-mfa></pwr-mfa>`;
export default loginHelpDeliveryOptionsTemplate;
